// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"7fd7c3cf","513":"cf0703a0","787":"194cecbf"}[chunkId] + ".chunk.js";
};